import React, { useEffect, useState, useRef } from "react";
import {
  tConv24,
  rearrangeDataForWeekView,
  calendarWidgetVisitTypeBasedColor
} from "../../../calendarFunctions";
import Wrap from "../../../../../hoc/Wrap";
import { isSet } from "../../../../../utils/commonUtils";
import { getCurrentTime } from "../../../../../utils/commonUtils";

// ✅ Convert "HH:MM AM/PM" → total minutes since midnight
const timeToMinutes = (timeStr) => {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;
  return hours * 60 + minutes;
};

const WeekViewBody = (props) => {
  const {
    timeInterval,
    currentWeek,
    showMoreDetailsDataHandler,
    todayDate,
    blockedDates = [],
    blockedDays = [],
    availabilitySlots = {}
  } = props;

  const calendarWeeksRecords = rearrangeDataForWeekView(props.calendarRecords);
  const weekdayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const [currentTimePosition, setCurrentTimePosition] = useState(null);
  const tableRef = useRef(null);

  // ✅ Updated logic to place the line between 12:00 PM and 12:15 PM
  useEffect(() => {
    // Condition to only show the line if there are records
    if (Object.keys(calendarWeeksRecords).length === 0) {
      setCurrentTimePosition(null); // Explicitly hide the line
      return;
    }

    const updateBlueLinePosition = () => {
      // const orgTime = "12:00 PM";
      const orgTime = getCurrentTime();
            // const orgTime ="12:00PM";
      const slots = tableRef.current?.querySelectorAll("tr");
      if (!slots || slots.length === 0) return;

      const orgTimeMinutes = timeToMinutes(orgTime);

      for (let i = 0; i < slots.length; i++) {
        const currentSlot = slots[i];
        const timeStr = currentSlot.getAttribute("data-time");
        if (timeStr && timeToMinutes(timeStr) === orgTimeMinutes) {
          const mainSlotOffset = currentSlot.offsetTop;
          const nextSlot = slots[i + 1]; // This is the 'fc-minor' row
          
          if (nextSlot) {
            const nextSlotOffset = nextSlot.offsetTop;
            // Calculate the midpoint between the two rows
            const midpoint = (mainSlotOffset + nextSlotOffset) / 2;
            setCurrentTimePosition(midpoint);
            return;
          }
        }
      }
    };

    updateBlueLinePosition();
    window.addEventListener('resize', updateBlueLinePosition);
    const intervalId = setInterval(updateBlueLinePosition, 60000);

    return () => {
      window.removeEventListener('resize', updateBlueLinePosition);
      clearInterval(intervalId);
    };
}, [timeInterval, calendarWeeksRecords]);

  // ✅ Check if a date is today
  const isToday = (date) => {
    return (
      new Date(date).setHours(0, 0, 0, 0) ===
      new Date(todayDate).setHours(0, 0, 0, 0)
    );
  };

  return (
    <tbody className="fc-body">
      <tr>
        <td className="fc-widget-content">
          <div
            className="fc-scroller fc-time-grid-container"
            style={{ position: "relative" }}
          >
            <div className="fc-time-grid">

              {/* Background cells */}
              <div className="fc-bg">
                <table>
                  <tbody>
                    <tr>
                      <td className="fc-axis fc-widget-content" style={{ width: '47.7px' }}></td>
                      {currentWeek.map((item, itemIndex) => {
                        let classArr = [];
                        if (isToday(item.date)) classArr.push("fc-day-today");
                        return (
                          <td
                            key={itemIndex}
                            className={`fc-day fc-widget-content fc-${item.displayWeekday} ${classArr.join(
                              " "
                            )} fc-past`}
                            data-date={item.c_date}
                          ></td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Time slots */}
              <div className="fc-slats" style={{ position: "relative" }}>
                <table ref={tableRef}>
                  <tbody>
                    {timeInterval.map((time, timeIndex) => {
                      const timeIn12 = tConv24(time);
                      const timeMinutes = timeToMinutes(timeIn12);

                      return (
                        <Wrap key={'time' + timeIndex}>
                          {/* Main row */}
                          <tr data-time={time}>
                            <td className="fc-axis fc-time fc-widget-content" style={{ width: '47.7px' }}>
                              <span>{timeIn12}</span>
                            </td>

                            {currentWeek.map((dateItem, ind) => {
                              const weekdayName = weekdayNames[new Date(dateItem.date).getDay()];

                              // 1. Check if holiday (full-day block)
                              const holiday = blockedDates.find(b => b.date === dateItem.c_date);

                              // 2. Check if full-day blocked weekday
                              const isDayBlocked = blockedDays.includes(weekdayName);

                              // 3. Check if time is inside allowed slots
                              const slots = availabilitySlots[weekdayName] || [];
                              let isTimeAllowed = true;

                              if (slots.length > 0) {
                                isTimeAllowed = slots.some(slot => {
                                  return timeMinutes >= timeToMinutes(slot.from_time) &&
                                    timeMinutes <= timeToMinutes(slot.to_time);
                                });
                              }

                              // Final blocking condition
                              const isBlocked = holiday || isDayBlocked || (slots.length > 0 && !isTimeAllowed);

                              const itemData = isSet(calendarWeeksRecords?.[dateItem.c_date]?.[timeIn12], []);

                              return (
                                <td
                                  key={ind}
                                  data-date={dateItem.c_date}
                                  className={`fc-widget-content ${isBlocked ? 'fc-day-blocked' : ''}`}
                                  style={isBlocked ? { cursor: "not-allowed" } : {}}
                                  title={holiday ? holiday.reason : isDayBlocked?"Clinic Not Available":(slots.length > 0 && !isTimeAllowed)? "Outside Available Hours":""} 
                                  onClick={() => {
                                    if (!isBlocked) {
                                      props.addVisitToogleHandler({
                                        visit_date: dateItem.c_date,
                                        visit_time: timeIn12
                                      });
                                    }
                                  }}
                                >
                                 
                                  {itemData.map((item, idx) => {
                                    if (idx > 1) return null;
                                    const typeBasedClass = calendarWidgetVisitTypeBasedColor(item.visit_category, 'GRID', item.visit_status);
                                    return (
                                      <React.Fragment key={idx}>
                                        <a
                                          title={`${item.visit_time} : ${item.employee.first_name} ${item.employee.last_name}`}
                                          onClick={(e) => { e.stopPropagation(); props.showQuickVisitView(e, item); }}
                                        >
                                          <div className={`mainValueTag ${typeBasedClass}`} data-toggle="dropdown">
                                            <span className="text-sm font-weight-bold">{item.visit_time}</span>
                                            <span className="font-weight-bold"> : </span>
                                            <span className="text-sm">{item.employee.first_name} {item.employee.last_name}</span>
                                          </div>
                                        </a>
                                        {idx === 1 && itemData.length > 2 && (
                                          <a
                                            className="text-danger textUnderline text-small quick-sidebar-toggler cursor-pointer"
                                            onClick={(e) =>
                                              showMoreDetailsDataHandler(e, { date: dateItem.c_date, time: timeIn12 }, isSet(itemData, []))
                                            }
                                          >
                                            + More ...
                                          </a>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                              );
                            })}
                          </tr>

                          {/* Minor row */}
                          <tr className="fc-minor" id={`calendarRow_${(time.toString().replace(':', ''))}`}>
                            <td className="fc-axis fc-time fc-widget-content" style={{ width: '47.7px' }}></td>
                            {currentWeek.map((dateItem, ind) => {
                              const weekdayName = weekdayNames[new Date(dateItem.date).getDay()];
                              const holiday = blockedDates.find(b => b.date === dateItem.c_date);
                              const isDayBlocked = blockedDays.includes(weekdayName);
                              const slots = availabilitySlots[weekdayName] || [];
                              let isTimeAllowed = true;

                              if (slots.length > 0) {
                                isTimeAllowed = slots.some(slot => {
                                  return timeMinutes >= timeToMinutes(slot.from_time) &&
                                    timeMinutes <= timeToMinutes(slot.to_time);
                                });
                              }

                              const isBlocked = holiday || isDayBlocked || (slots.length > 0 && !isTimeAllowed);

                              return (
                                <td
                                  key={'timebottom' + ind}
                                  data-date={dateItem.c_date}
                                  className={`fc-widget-content ${isBlocked ? 'fc-day-blocked' : ''}`}
                                  style={isBlocked ? { cursor: "not-allowed" } : {}}
                                  title={holiday ? holiday.reason : isDayBlocked?"Clinic Not Available":(slots.length > 0 && !isTimeAllowed)? "Outside Available Hours":""} 
                                  onClick={() => {
                                    if (!isBlocked) {
                                      props.addVisitToogleHandler({
                                        visit_date: dateItem.c_date,
                                        visit_time: timeIn12
                                      });
                                    }
                                  }}
                                ></td>
                              );
                            })}
                          </tr>
                        </Wrap>
                      );
                    })}
                  </tbody>
                </table>

                {/* ✅ Current Time Line & Circle */}
                {currentTimePosition !== null && (
                  <>
                    <div
                      style={{
                        position: "absolute",
                        top: `${currentTimePosition}px`,
                        left: "0",
                        right: "0",
                        height: "3px",
                        backgroundColor: "#174ADD",
                        zIndex: 10
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: `${currentTimePosition - 4}px`,
                        left: "0",
                        width: "10px",
                        height: "10px",
                        backgroundColor: "#174ADD",
                        borderRadius: "50%",
                        zIndex: 15
                      }}
                    ></div>
                  </>
                )}
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

WeekViewBody.defaultProps = {
   isShowActivities:false
}
export default WeekViewBody;